<template>
  <div class="relative mt25">
    <div class="image-container">
      <img class="image" v-lazy="'/assets/eg-sellwithus-full.png'" :alt="'Why E-Garderobe image'">
    </div>
    <div class="absolute flex center-xs text-block">
      <h2 class="center-xs text-block-header">
        {{ $t("Sell with us v2") }}
      </h2>
      <button-full class="text-block-button" :link="'/selling'">
        {{ $t('Fill out the form') }}
      </button-full>
    </div>
  </div>
</template>

<script>
import ButtonFull from 'src/themes/theme-egarderobe/components/theme/ButtonFull.vue'

export default {
  name: 'ImageBlock',
  components: {
    ButtonFull
  },
}
</script>

<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $color-white: color(white);

  .image-container {
    @media (max-width: 767px) {
      padding-top: 35%;
    }
    position: relative;
    height: 0;
    overflow: hidden;
    padding-top: 20%;
  }
  .image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
  .text-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    top: 50%;
    left: 70%;
    transform: translate(-50%, -50%);
    font-weight: 400;
    min-width: 40%;
  }
  .text-block-header {
    @media (max-width: 1025px) {
      font-size: 24px;
    }
    @media (max-width: 767px) {
      font-size: 16px;
    }
    font-family: 'Poppins';
    margin: 0;
    font-size: 35px;
    color: #000;
  }
  .text-block-button {
    width: fit-content;
  }
</style>
